import FullPageModal from "@/modules/common/components/ui-kit/full-page-modal/full-page-modal";
import { Track } from "../../types";
import DrawingProposalsTab from ".";

function DrawingProposalsMobileTab({
  open,
  onClose,
  track,
}: Readonly<{
  open: boolean;
  onClose: () => void;
  track: Track;
}>) {
  return (
    <FullPageModal isOpen={open} onClose={onClose} title="Drawing Proposals">
      <DrawingProposalsTab
        propertyUid={track.property.uid}
        customerUid={track.owner?.uid ?? ""}
        isContractSigned={track.status.name.toLowerCase() === "contract signed"}
      />
    </FullPageModal>
  );
}

export default DrawingProposalsMobileTab;
